var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfIcon = function SvgPdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    fillRule: "evenodd",
    d: "M8 3a1 1 0 0 0-1 1v32a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V11.579a1 1 0 0 0-.292-.706l-7.552-7.579A1 1 0 0 0 24.448 3zm1 32V5h14v7a1 1 0 0 0 1 1h7v22zm21.011-24L25 5.971V11zm-13.39 9.58q0 1.036-.649 1.586-.648.549-1.843.549h-.585V25h-1.362v-6.425h2.052q1.17 0 1.778.503.609.504.609 1.501m-3.077 1.019h.449q.628 0 .94-.249.312-.247.312-.723 0-.479-.261-.707-.262-.229-.82-.229h-.62zm8.717 2.557q.903-.843.903-2.43 0-1.49-.87-2.32t-2.443-.83h-2.017V25h1.819q1.705 0 2.608-.844m-.512-2.395q0-2.07-1.828-2.07h-.725v4.184h.584q1.97 0 1.969-2.114M24.496 25h1.34v-2.54h2.18v-1.112h-2.18v-1.657h2.342v-1.116h-3.682z",
    clipRule: "evenodd"
  })));
};
export default SvgPdfIcon;